// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__2WBTT","opacity":"Modal_opacity__1fwZX","Backdrop":"Modal_Backdrop__1MWMP","Content":"Modal_Content__v6gnm","Close":"Modal_Close__1coF5"};